import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getUserError, getUserStatus } from '../store/slices/userSlice';
import $ from "jquery"
import 'datatables.net'
import Modal from 'react-modal';
import GooglePlacesAutocomplete, { geocodeByPlaceId, getLatLng } from 'react-google-places-autocomplete';
import { addLake, deleteLake, editLake, getAllLakes } from '../store/featureActions';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: "30%",
        overFlow: 'hidden',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
Modal.setAppElement('#root');
const AllLakes = () => {
    const [id, setId] = useState()
    const dispatch = useDispatch()
    const status = useSelector(getUserStatus)
    const error = useSelector(getUserError)
    const [lakeList, setLakeList] = useState(null)
    const [detail, setDetail] = useState(null)
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalType, setModalType] = useState()
    const [lat, setLat] = useState('')
    const [name, setName] = useState('')
    const [long, setLong] = useState('')
    const [value, setValue] = useState(null);

    function viewModal(item, type) {
        setIsOpen(true);
        if (type == "detail") {
            setDetail(item)
        } else if (type == "create") {
            setId(item)
        } else if (type == "delete") {
            setId(item)
        } else if (type == "edit") {
            setDetail(item)
            setId(item?._id)
        }
        setModalType(type)
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
        setName()
        setLong()
        setLat()
    }

    const lakeDelete = async (id) => {
        try {
            let payload = {
                params: id,
                isToast:true
              }
            await dispatch(deleteLake(payload)).unwrap()
            setIsOpen(false)
            $('#tableData')
                .DataTable().destroy();
            try {
                listLake()
            } catch (rejectedValueOrSerializedError) {
                console.log(rejectedValueOrSerializedError)
            }
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    if (value) {
        geocodeByPlaceId(value?.value?.place_id)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                if (lat && lng) {
                    setLat(lat)
                    setName(value?.label)
                    setLong(lng)
                }
            })
    }
    const lakeAdd = async () => {
        let payload = {
            body: {
                'name': name,
                'lat': lat,
                'long': long,
            },
            params: false,
            isToast:true
        }
        try {
            await dispatch(addLake(payload)).unwrap()
            setIsOpen(false)
            setName()
            setLong()
            setLat()
            if (lakeList) {
                $('#tableData')
                    .DataTable().destroy();
            }
            listLake()
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const lakeEdit = async () => {
        try {
            let payload = {
                body: {
                    'name': name,
                    'lat': lat,
                    'long': long,
                },
                params: id,
                isToast:true
            }
            await dispatch(editLake(payload)).unwrap()
            setIsOpen(false)
            $('#tableData')
                .DataTable().destroy();
            listLake()
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const listLake = async () => {
        try {
            setLakeList(null)
            let payload = {
                params: false,
                isToast:false
            }
            const response = await dispatch(getAllLakes(payload)).unwrap()
            setLakeList(response?.data?.lakes)
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    useEffect(() => {
        let mount = true
        if (mount) {
            listLake();
        }
        return () => {
            mount = false
        }
    }, [])
    useEffect(() => {
        if (lakeList) {
            $('#tableData')
                .DataTable({
                    lengthMenu: [10, 25, 50, 100, 200],
                    language: {
                        "emptyTable": "Lake List Not Found"
                    },
                    destroy: true,
                });
        }
    }, [lakeList])
    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Change Password"
            >
                <div className='change-password-modal' id="exampleModalCenter" tabIndex={-1} aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block", zIndex: 100 }}>
                    {modalType == "detail" ? <>
                        <p className="pass-text">Detail</p>
                        <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        <div className="modal-body">
                            <p > <b>{detail?.mainType == "videos" ? "Video Thumbnail:" : "Article Preview:"}</b> {detail?.mainType == "videos" ? detail?.videoThumbnail ? <><img height="20%" width="20%" style={{ borderRadius: 5 }} src={`${detail?.videoThumbnail}`}></img></> : <>No Image Found</> : detail?.articlePreview ? <>{detail?.articlePreview}</> : <>No Preview Found</>}</p>
                            <p > <b>{detail?.mainType == "articles" ? "Article Link:" : "Video Link:"}</b> {detail?.mainType == "articles" ? detail?.articleLink ? <>{detail?.articleLink}</> : <>No Link Found</> : detail?.videoLink ? <>{detail?.videoLink}</> : <>No Link Found</>}</p>
                        </div>
                    </> : modalType == "create" ? <>
                        <p className="pass-text">Add Lake</p>
                        <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        <div className="modal-body">
                            <div className="mb-4">
                                <GooglePlacesAutocomplete
                                    selectProps={{
                                        isClearable: true,
                                        placeholder: 'Select Lake',
                                        value,
                                        onChange: setValue,
                                        styles: {
                                            input: (provided) => ({
                                                ...provided,
                                                padding: 10
                                            }),
                                        }
                                    }} />
                            </div>
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={lakeAdd}>Add</button>
                        </div>
                    </> : modalType == "edit" ? <>
                        <p className="pass-text">Edit Lake</p>
                        <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        <div className="modal-body">
                            <div className="mb-4">
                                <GooglePlacesAutocomplete
                                    selectProps={{
                                        isClearable: true,
                                        placeholder: 'Select Lake',
                                        value,
                                        onChange: setValue,
                                        styles: {
                                            input: (provided) => ({
                                                ...provided,
                                                padding: 10
                                            }),
                                        }
                                    }} />
                            </div>
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={lakeEdit}>Update</button>
                        </div>
                    </> : modalType == "delete" ? <>
                        <p className="pass-text">Delete Lake Confirmation</p>
                        <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        <div className="modal-body">
                            <form >
                                <div className="pass-form-wrap" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                    <div className="login-button mt-2" style={{ width: "40%" }}>
                                        <button type="button" onClick={() => lakeDelete(id)} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Delete</button>
                                    </div>
                                    <div className="login-button mt-2" style={{ width: "40%" }} >
                                        <button type="button" onClick={closeModal} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </> : <></>}
                </div>
            </Modal>
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: lakeList ? "3%" : "12%"
            }}>
                {/* <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className=" mt-2 mb-3 d-flex justify-content-end">
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} onClick={() => viewModal(null, "create")} >Add Lake
                            </button>
                        </div>
                    </div>
                </section> */}
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="card shadow mb-4">
                                    <div className="card-body">
                                        <div className="table-responsive" id="tableready">
                                            <table id="tableData" className="table table-bordered display" style={{ width: '100%', textAlign: "center" }}>
                                                <thead>
                                                    {lakeList ? (<tr>
                                                        <th>S.No</th>
                                                        <th>Lake Name</th>
                                                        <th>Game Played</th>
                                                        {/* <th>Action</th> */}
                                                    </tr>) : (<tr></tr>)}
                                                </thead>
                                                <tbody >
                                                    {lakeList?.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td style={{ textAlign: "start" }}>{item?.name}</td>
                                                            <td style={{ textAlign: "center" }}>{item?.playedCount}</td>
                                                            {/* <td>
                                                                <span className="edit-icon" >
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item, "edit")}  ><i className="fa fa-solid fa-edit"></i> Edit</span>
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item?._id, "delete")}  ><i className="fas fa-trash-alt"></i> Delete</span>
                                                                </span>
                                                            </td> */}
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                                {!lakeList ?
                                                    status == "loading" || error ? <tfoot>
                                                        <tr><th>{status == "loading" ? "Loading..." : error ? error : ""}</th></tr>
                                                    </tfoot> : <></> : <></>}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        </>
    )
}
export default AllLakes
